import axios from 'axios'
import {
  Message,
  MessageBox
} from 'element-ui'

// 创建axios实例
const http = axios.create({
  baseURL: process.env.VUE_APP_BASEURL, // api的base_url
  timeout: 5000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

// request拦截器
http.interceptors.request.use(config => {
  // if (store.getters.token) { // todo;加上这个请求会报错
  //   console.log(getToken(), 22222)
  //   config.headers['X-Token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  // }
  // if (config.method === 'post' && config.data && config.data.constructor !== FormData) {
  //   config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
  // }
  return config
}, error => {
  // Do something with request error
  Promise.reject(error)
})

http.interceptors.response.use(
  response => {
    /**
     * code为非200是抛错 可结合自己业务进行修改
     */
    const res = response.data
    return response.data
  },
  error => {
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default http
